import React from "react";
import LearningPlanExamResults from "./LearningPlanExamResults";

export default class LearningPlanExamSuccessPostTest extends React.Component {
  constructor(props) {
    super(props);

    this.pageRef = React.createRef();
    this.onPrint = this.onPrint.bind(this);
  }

  render() {
    // console.log("LearningPlanExamSuccessPostTest", this.props);
    const { is_admin = false, title, standalone = false } = this.props;
    const knowledge = this.getResultItem("KNOWLEDGE");
    const { score } = knowledge;
    const { raw: correct, rawMax: total } = score;
    return (
      <div
        ref={this.pageRef}
        className="learning-plan-exam-success with-results"
        style={
          is_admin && !standalone
            ? { height: $(window).innerHeight() - 169, overflow: "scroll" }
            : {}
        }
      >
        {is_admin ? null : (
          <div className="bordered-heading">
            <h1>
              {this.props.course ? (
                <span>
                  {I18n.t("posttest")}: {this.props.course.name}
                </span>
              ) : (
                title
              )}
            </h1>
          </div>
        )}
        {standalone ? (
          <h1>
            {this.props.course ? (
              <span>
                {I18n.t("posttest")}: {this.props.course.name}
              </span>
            ) : (
              title
            )}
          </h1>
        ) : null}
        <h2
          style={{ marginTop: 0, marginBottom: "1rem", position: "relative" }}
        >
          {I18n.t("score_blank_out_of_blank", {
            correct: correct,
            total: total,
          })}
          {this.props.testId ? (
            <a
              target="_blank"
              href={`/classroom/${this.props.learning_plan.account_public_id}/learning_plan_exam_results/${this.props.testId}`}
              className="btn btn-secondary btn-sm"
              style={{ position: "absolute", top: "0", right: "0" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-printer-fill"
                viewBox="0 0 16 16"
              >
                <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1" />
                <path d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
              </svg>
            </a>
          ) : null}
        </h2>
        {this.renderPersonalData()}
        {this.renderCompletedAt()}
        <LearningPlanExamResults {...this.props} articleLinks={true} />
        {!is_admin ? (
          <p style={{ paddingBottom: "1rem" }}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                // window.location.reload();
                this.props.onHide();
              }}
              className="btn"
            >
              {I18n.t("continue_learning")}
            </a>
          </p>
        ) : null}
      </div>
    );
  }

  renderCompletedAt() {
    const { testCompletedAt } = this.props;
    const date = new Date(testCompletedAt);
    if (date instanceof Date && !isNaN(date)) {
      return (
        <h6 style={{ marginBottom: "1rem" }}>
          {I18n.t("submitted_on", {
            date: date.toLocaleDateString("en-us", {
              weekday: "long",
              year: "numeric",
              month: "short",
              day: "numeric",
            }),
            time: date.toLocaleTimeString("en-us", {
              hour: "numeric",
              minute: "numeric",
            }),
          })}
        </h6>
      );
    }
  }

  renderPersonalData() {
    const { personalData = {} } = this.props;
    const { fields = [] } = personalData;
    const first_name = fields.find((field) => field.name === "firstName");
    const last_name = fields.find((field) => field.name === "lastName");
    const email_address = fields.find((field) => field.name === "emailAddress");

    if (
      first_name &&
      first_name.value &&
      last_name &&
      last_name.value &&
      email_address &&
      email_address.value
    ) {
      return (
        <h6>
          {first_name.value.asString} {last_name.value.asString} (
          {email_address.value.asString})
        </h6>
      );
    }
  }

  getResultItem(name) {
    const { results = [] } = this.props;
    return results.find((result) => result.type === name);
  }

  onPrint(e) {
    e.preventDefault();
    e.stopPropagation();
    console.log("onPrint", this.props.testId);

    const hideFrame = document.createElement("iframe");
    hideFrame.onload = () => {
      const closePrint = () => {
        document.body.removeChild(this);
      };
      this.contentWindow.onbeforeunload = closePrint;
      this.contentWindow.onafterprint = closePrint;
      this.contentWindow.print();
    };
    hideFrame.style.display = "none";
    hideFrame.src =
      "/classroom/" +
      this.props.learning_plan.account_public_id +
      "/learning_plan_exam_results/" +
      this.props.testId;
    document.body.appendChild(hideFrame);
  }
}
